import { getCurrentAuthMethod } from 'auth/auth-methods/current-auth-method';
import { AuthStore } from 'auth/storage/auth-storage-manager';
import { IdentificationState } from 'auth/types/identification-state.type';
import { TokenResponse } from 'auth/types/token-response.type';
import { UserInfo } from 'auth/types/user-info.type';
import { Env } from 'types';

export const getInitialIdentificationState = (env: Env): IdentificationState => {
  const userInfo = AuthStore.getUserInfo();
  const token = AuthStore.getAuthToken();
  const { isUsingWebseal } = getCurrentAuthMethod(env);
  const isUserInStorageValid = userInfo && token && token.token_expiry_time > new Date();
  if (isUserInStorageValid || isUsingWebseal) return 'authenticated';
  return 'unidentified';
};

export const getInitialSignedInUser = (): UserInfo | undefined => {
  const userInfo = AuthStore.getUserInfo();
  const token = AuthStore.getAuthToken();
  if (!userInfo || !token || token.token_expiry_time < new Date()) return undefined;
  return userInfo;
};

export const getInitialToken = (): TokenResponse | undefined => {
  const token = AuthStore.getAuthToken();
  if (token && token.token_expiry_time > new Date()) return token;
  return undefined;
};
